import { getUtiqConsentManagerScriptPath } from '@shared/getScriptPath';
import { consoleLogger } from '@shared/logging/consoleLogger';

export const showConsentManager = () => {
  const utiqConsentManager = document.createElement('script');
  utiqConsentManager.setAttribute('id', 'utiq__consent-manager');
  utiqConsentManager.src = getUtiqConsentManagerScriptPath();
  document.head.appendChild(utiqConsentManager);
  consoleLogger.logDebug('Consent manager appended to the document head');
  window.Utiq ||= {};
  window.Utiq.consentManagerShown = true;
};
